import PropTypes from 'prop-types';
import React from 'react';

import DetailsTileField, { DetailsTileFieldDataShape } from './DetailsTileField';

const DetailsTile = ({ title, href, fields }) => {
  const renderFields = fields.map(field => <DetailsTileField key={field.title} data={field} />);

  return (
    <>
      <div className="your-data-card__title">{title}</div>
      <div className="your-data-card__body">{renderFields}</div>
      {href && (
        <a className="your-data-card__action" href={href}>
          <i className="icon-cog" />
        </a>
      )}
    </>
  );
};

DetailsTile.propTypes = {
  title: PropTypes.string,
  href: PropTypes.string,
  fields: PropTypes.arrayOf(DetailsTileFieldDataShape),
};

export default DetailsTile;
